import { connect } from 'react-redux';
import { compose, hoistStatics, withState, withProps } from 'recompose';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import CheckPath from './CheckPath';


const mapStateToProps = state => ({
  pages: state.modules.pages,
  pagesSettings: state.modules.pagesSettings,
  defaultRoute: state.settings.defaultRoute,
});


const enhance = compose(
  connect(mapStateToProps, null),
  withState('isLoading', 'setIsLoading', false),
  translate('portal'),
  withProps(props => ({
    pathName: props.location.pathname.slice(1),
  })),
);

export default withRouter(hoistStatics(enhance)(CheckPath));



// WEBPACK FOOTER //
// ./src/components/checkPath/index.js